export default __webpack_public_path__ + "static/media/TopBarPersonIcon.46e685b2.svg";